/**
 * $SILKAI token + Link Guard external links - single source of truth.
 */
export const SILKAI = {
  ticker: '$SILKAI',
  mint: '46N2MGuREKceuWCCHjniQJVu66c2zLc9uwjXGfREvory',
  pair: 'EupeYRMSeqyno3jyFtbZ4CCTt94ozfevnAPwTF5Sh9sD',
  jupiter: 'https://jup.ag/tokens/46N2MGuREKceuWCCHjniQJVu66c2zLc9uwjXGfREvory',
  dexscreener: 'https://dexscreener.com/solana/eupeyrmseqyno3jyftbz4cctt94ozfevnapwtf5sh9sd',
  orynth: 'https://www.orynth.dev/projects/silker-ai',
} as const;

/**
 * Telegram bot handle for Link Guard. Override at build time with
 * NEXT_PUBLIC_LINK_GUARD_BOT for environment-specific bots.
 */
export const LINK_GUARD_BOT: string =
  process.env.NEXT_PUBLIC_LINK_GUARD_BOT || 'SilkerLinkGuardBot';

export const LINK_GUARD_BOT_URL = `https://t.me/${LINK_GUARD_BOT}`;
